module.exports = __webpack_public_path__ + "static/media/upliftLogo.c50f92ad.png";